import { Outlet } from 'react-router';
import { pathURL } from '@/components/constants/urls';
import { useUserLanguage } from '@/customHooks';
import NavTabs from '../molecules/NavTabs';

const textsData = {
  en: {
    title: 'Contracts',
    tenantContractsLabel: 'Tenant',
    ownerContractsLabel: 'Owner',
  },
  es: {
    title: 'Contratos',
    tenantContractsLabel: 'Inquilinos',
    ownerContractsLabel: 'Propietarios',
  }
}

export const ContractsListPage = () => {
  const userLanguage = useUserLanguage();
  const texts = userLanguage === 'es' ? textsData.es : textsData.en;

  return (
    <div className="w-full h-full flex flex-col">
      <div className="flex justify-between items-center px-4 py-6 border-b border-gray-100 bg-white/50 backdrop-blur-md sticky top-0 z-20">
        <h1 className="text-3xl font-extrabold text-gray-900 tracking-tight">
          {texts.title}
        </h1>
        <div className="flex items-center">
          <NavTabs
            tabs={[
              { 
                label: texts.tenantContractsLabel, 
                href: `/${pathURL.USER}/${pathURL.CONTRACT}/${pathURL.TENANT}` 
              },
              { 
                label: texts.ownerContractsLabel, 
                href: `/${pathURL.USER}/${pathURL.CONTRACT}/${pathURL.OWNER}` 
              },
            ]}
            defaultActive={texts.tenantContractsLabel}
          />
        </div>
      </div>
      <div className="flex-1 overflow-y-auto">
        <Outlet />
      </div>
    </div>
  );
}
